import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { machineGroups } from "api/myMachines";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const DemoPaper = styled(Paper)(({ theme }) => ({
  width: "100%",
  padding: theme.spacing(3),
  ...theme.typography.body2,
  textAlign: "left",
  backgroundColor: "#f9f9f9",
}));

function MachinesGroups() {
  const [groupList, setGroupList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:600px)");
  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const { data } = await machineGroups();
        setGroupList(data || []);
      } catch (err) {
        setError("Failed to load machine groups.");
      } finally {
        setLoading(false);
      }
    };
    fetchGroups();
  }, []);

  if (loading)
    return (
      <Stack
        spacing={2}
        sx={{
          height: "80vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress sx={{ color: "#424242" }} />
      </Stack>
    );
  if (error)
    return (
      <Stack
        spacing={2}
        sx={{
          height: "80vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography color="error">{error}</Typography>
        <Box
          sx={{
            width: "100%",
            maxWidth: "150px",
            height: "40px",
            backgroundColor: "#424242",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "&:hover": {
              backgroundColor: "#686868",
            },
            flexShrink: 0,
            margin: "10px",
          }}
        >
          <Button
            sx={{
              color: "#ffffff",
              textTransform: "none",
            }}
            onClick={() => window.location.reload()}
          >
            Retry
          </Button>
        </Box>
      </Stack>
    );
  return (
    <>
      <Stack direction="column" spacing={2} marginX={2} marginY={4}>
        <Typography
          color="text.primary"
          marginX={5}
          variant="h5"
          sx={{ fontWeight: "bold", mb: 1 }}
        >
          <strong>Mine maskiner</strong>
        </Typography>

        {groupList.map(({ id, name, description }) => (
          <Stack
            direction="row"
            spacing={2}
            marginX={5}
            marginY={2}
            key={id}
            onClick={() => navigate(`/group/${id}`)}
            sx={{
              alignItems: "center",
            }}
          >
            <DemoPaper>
              <Stack
                direction={"row"}
                sx={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Stack spacing={1}>
                  <Typography variant="h6" color="#424242">
                    {name}
                  </Typography>
                  <Typography variant="body2">{description}</Typography>
                </Stack>
                <IconButton
                  sx={{
                    transform: "rotate(-90deg)",
                  }}
                >
                  <ExpandCircleDownOutlinedIcon />
                </IconButton>
              </Stack>
            </DemoPaper>
          </Stack>
        ))}
      </Stack>
    </>
  );
}

export default MachinesGroups;
